/**
 * @fileoverview gRPC-Web generated client stub for wisetime.user.timeline.v4
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: wisetime/user/timeline/v4/timeline.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';
import * as wisetime_user_timeline_v4_timeline_pb from '../../../../wisetime/user/timeline/v4/timeline_pb';
import * as wisetime_user_type_timeline_status_pb from '../../../../wisetime/user/type/timeline_status_pb';


export class TimelineServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorListTimelines = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/ListTimelines',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.ListTimelinesRequest,
    wisetime_user_timeline_v4_timeline_pb.ListTimelinesResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.ListTimelinesRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.ListTimelinesResponse.deserializeBinary
  );

  listTimelines(
    request: wisetime_user_timeline_v4_timeline_pb.ListTimelinesRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.ListTimelinesResponse>;

  listTimelines(
    request: wisetime_user_timeline_v4_timeline_pb.ListTimelinesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.ListTimelinesResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.ListTimelinesResponse>;

  listTimelines(
    request: wisetime_user_timeline_v4_timeline_pb.ListTimelinesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.ListTimelinesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/ListTimelines',
        request,
        metadata || {},
        this.methodDescriptorListTimelines,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/ListTimelines',
    request,
    metadata || {},
    this.methodDescriptorListTimelines);
  }

  methodDescriptorGetTimelineStatus = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/GetTimelineStatus',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.GetTimelineStatusRequest,
    wisetime_user_type_timeline_status_pb.TimelineStatus,
    (request: wisetime_user_timeline_v4_timeline_pb.GetTimelineStatusRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_type_timeline_status_pb.TimelineStatus.deserializeBinary
  );

  getTimelineStatus(
    request: wisetime_user_timeline_v4_timeline_pb.GetTimelineStatusRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_type_timeline_status_pb.TimelineStatus>;

  getTimelineStatus(
    request: wisetime_user_timeline_v4_timeline_pb.GetTimelineStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_type_timeline_status_pb.TimelineStatus) => void): grpcWeb.ClientReadableStream<wisetime_user_type_timeline_status_pb.TimelineStatus>;

  getTimelineStatus(
    request: wisetime_user_timeline_v4_timeline_pb.GetTimelineStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_type_timeline_status_pb.TimelineStatus) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/GetTimelineStatus',
        request,
        metadata || {},
        this.methodDescriptorGetTimelineStatus,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/GetTimelineStatus',
    request,
    metadata || {},
    this.methodDescriptorGetTimelineStatus);
  }

  methodDescriptorListDaySummaries = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/ListDaySummaries',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.ListDaySummariesRequest,
    wisetime_user_timeline_v4_timeline_pb.ListDaySummariesResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.ListDaySummariesRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.ListDaySummariesResponse.deserializeBinary
  );

  listDaySummaries(
    request: wisetime_user_timeline_v4_timeline_pb.ListDaySummariesRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.ListDaySummariesResponse>;

  listDaySummaries(
    request: wisetime_user_timeline_v4_timeline_pb.ListDaySummariesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.ListDaySummariesResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.ListDaySummariesResponse>;

  listDaySummaries(
    request: wisetime_user_timeline_v4_timeline_pb.ListDaySummariesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.ListDaySummariesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/ListDaySummaries',
        request,
        metadata || {},
        this.methodDescriptorListDaySummaries,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/ListDaySummaries',
    request,
    metadata || {},
    this.methodDescriptorListDaySummaries);
  }

  methodDescriptorListTimeRowsByDate = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/ListTimeRowsByDate',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.ListTimeRowsByDateRequest,
    wisetime_user_timeline_v4_timeline_pb.ListTimeRowsByDateResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.ListTimeRowsByDateRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.ListTimeRowsByDateResponse.deserializeBinary
  );

  listTimeRowsByDate(
    request: wisetime_user_timeline_v4_timeline_pb.ListTimeRowsByDateRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.ListTimeRowsByDateResponse>;

  listTimeRowsByDate(
    request: wisetime_user_timeline_v4_timeline_pb.ListTimeRowsByDateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.ListTimeRowsByDateResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.ListTimeRowsByDateResponse>;

  listTimeRowsByDate(
    request: wisetime_user_timeline_v4_timeline_pb.ListTimeRowsByDateRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.ListTimeRowsByDateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/ListTimeRowsByDate',
        request,
        metadata || {},
        this.methodDescriptorListTimeRowsByDate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/ListTimeRowsByDate',
    request,
    metadata || {},
    this.methodDescriptorListTimeRowsByDate);
  }

  methodDescriptorWatchTimelineUpdates = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/WatchTimelineUpdates',
    grpcWeb.MethodType.SERVER_STREAMING,
    wisetime_user_timeline_v4_timeline_pb.WatchTimelineUpdatesRequest,
    wisetime_user_timeline_v4_timeline_pb.TimelineUpdate,
    (request: wisetime_user_timeline_v4_timeline_pb.WatchTimelineUpdatesRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.TimelineUpdate.deserializeBinary
  );

  watchTimelineUpdates(
    request: wisetime_user_timeline_v4_timeline_pb.WatchTimelineUpdatesRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.TimelineUpdate> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/wisetime.user.timeline.v4.TimelineService/WatchTimelineUpdates',
      request,
      metadata || {},
      this.methodDescriptorWatchTimelineUpdates);
  }

  methodDescriptorPostTime = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/PostTime',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.PostTimeRequest,
    wisetime_user_timeline_v4_timeline_pb.PostTimeResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.PostTimeRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.PostTimeResponse.deserializeBinary
  );

  postTime(
    request: wisetime_user_timeline_v4_timeline_pb.PostTimeRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.PostTimeResponse>;

  postTime(
    request: wisetime_user_timeline_v4_timeline_pb.PostTimeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.PostTimeResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.PostTimeResponse>;

  postTime(
    request: wisetime_user_timeline_v4_timeline_pb.PostTimeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.PostTimeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/PostTime',
        request,
        metadata || {},
        this.methodDescriptorPostTime,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/PostTime',
    request,
    metadata || {},
    this.methodDescriptorPostTime);
  }

  methodDescriptorCancelPostTime = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/CancelPostTime',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.CancelPostTimeRequest,
    wisetime_user_timeline_v4_timeline_pb.CancelPostTimeResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.CancelPostTimeRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.CancelPostTimeResponse.deserializeBinary
  );

  cancelPostTime(
    request: wisetime_user_timeline_v4_timeline_pb.CancelPostTimeRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.CancelPostTimeResponse>;

  cancelPostTime(
    request: wisetime_user_timeline_v4_timeline_pb.CancelPostTimeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.CancelPostTimeResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.CancelPostTimeResponse>;

  cancelPostTime(
    request: wisetime_user_timeline_v4_timeline_pb.CancelPostTimeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.CancelPostTimeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/CancelPostTime',
        request,
        metadata || {},
        this.methodDescriptorCancelPostTime,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/CancelPostTime',
    request,
    metadata || {},
    this.methodDescriptorCancelPostTime);
  }

  methodDescriptorAttachTag = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/AttachTag',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.AttachTagRequest,
    wisetime_user_timeline_v4_timeline_pb.AttachTagResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.AttachTagRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.AttachTagResponse.deserializeBinary
  );

  attachTag(
    request: wisetime_user_timeline_v4_timeline_pb.AttachTagRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.AttachTagResponse>;

  attachTag(
    request: wisetime_user_timeline_v4_timeline_pb.AttachTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.AttachTagResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.AttachTagResponse>;

  attachTag(
    request: wisetime_user_timeline_v4_timeline_pb.AttachTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.AttachTagResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/AttachTag',
        request,
        metadata || {},
        this.methodDescriptorAttachTag,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/AttachTag',
    request,
    metadata || {},
    this.methodDescriptorAttachTag);
  }

  methodDescriptorDetachTag = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/DetachTag',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.DetachTagRequest,
    wisetime_user_timeline_v4_timeline_pb.DetachTagResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.DetachTagRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.DetachTagResponse.deserializeBinary
  );

  detachTag(
    request: wisetime_user_timeline_v4_timeline_pb.DetachTagRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.DetachTagResponse>;

  detachTag(
    request: wisetime_user_timeline_v4_timeline_pb.DetachTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.DetachTagResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.DetachTagResponse>;

  detachTag(
    request: wisetime_user_timeline_v4_timeline_pb.DetachTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.DetachTagResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/DetachTag',
        request,
        metadata || {},
        this.methodDescriptorDetachTag,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/DetachTag',
    request,
    metadata || {},
    this.methodDescriptorDetachTag);
  }

  methodDescriptorDetachTagCategory = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/DetachTagCategory',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.DetachTagCategoryRequest,
    wisetime_user_timeline_v4_timeline_pb.DetachTagCategoryResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.DetachTagCategoryRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.DetachTagCategoryResponse.deserializeBinary
  );

  detachTagCategory(
    request: wisetime_user_timeline_v4_timeline_pb.DetachTagCategoryRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.DetachTagCategoryResponse>;

  detachTagCategory(
    request: wisetime_user_timeline_v4_timeline_pb.DetachTagCategoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.DetachTagCategoryResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.DetachTagCategoryResponse>;

  detachTagCategory(
    request: wisetime_user_timeline_v4_timeline_pb.DetachTagCategoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.DetachTagCategoryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/DetachTagCategory',
        request,
        metadata || {},
        this.methodDescriptorDetachTagCategory,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/DetachTagCategory',
    request,
    metadata || {},
    this.methodDescriptorDetachTagCategory);
  }

  methodDescriptorAcceptTagSuggestion = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/AcceptTagSuggestion',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.AcceptTagSuggestionRequest,
    wisetime_user_timeline_v4_timeline_pb.AcceptTagSuggestionResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.AcceptTagSuggestionRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.AcceptTagSuggestionResponse.deserializeBinary
  );

  acceptTagSuggestion(
    request: wisetime_user_timeline_v4_timeline_pb.AcceptTagSuggestionRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.AcceptTagSuggestionResponse>;

  acceptTagSuggestion(
    request: wisetime_user_timeline_v4_timeline_pb.AcceptTagSuggestionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.AcceptTagSuggestionResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.AcceptTagSuggestionResponse>;

  acceptTagSuggestion(
    request: wisetime_user_timeline_v4_timeline_pb.AcceptTagSuggestionRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.AcceptTagSuggestionResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/AcceptTagSuggestion',
        request,
        metadata || {},
        this.methodDescriptorAcceptTagSuggestion,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/AcceptTagSuggestion',
    request,
    metadata || {},
    this.methodDescriptorAcceptTagSuggestion);
  }

  methodDescriptorDeclineTagSuggestion = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/DeclineTagSuggestion',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.DeclineTagSuggestionRequest,
    wisetime_user_timeline_v4_timeline_pb.DeclineTagSuggestionResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.DeclineTagSuggestionRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.DeclineTagSuggestionResponse.deserializeBinary
  );

  declineTagSuggestion(
    request: wisetime_user_timeline_v4_timeline_pb.DeclineTagSuggestionRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.DeclineTagSuggestionResponse>;

  declineTagSuggestion(
    request: wisetime_user_timeline_v4_timeline_pb.DeclineTagSuggestionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.DeclineTagSuggestionResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.DeclineTagSuggestionResponse>;

  declineTagSuggestion(
    request: wisetime_user_timeline_v4_timeline_pb.DeclineTagSuggestionRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.DeclineTagSuggestionResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/DeclineTagSuggestion',
        request,
        metadata || {},
        this.methodDescriptorDeclineTagSuggestion,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/DeclineTagSuggestion',
    request,
    metadata || {},
    this.methodDescriptorDeclineTagSuggestion);
  }

  methodDescriptorSelectTimesheetFieldOption = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/SelectTimesheetFieldOption',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.SelectTimesheetFieldOptionRequest,
    wisetime_user_timeline_v4_timeline_pb.TimeGroup,
    (request: wisetime_user_timeline_v4_timeline_pb.SelectTimesheetFieldOptionRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.TimeGroup.deserializeBinary
  );

  selectTimesheetFieldOption(
    request: wisetime_user_timeline_v4_timeline_pb.SelectTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  selectTimesheetFieldOption(
    request: wisetime_user_timeline_v4_timeline_pb.SelectTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  selectTimesheetFieldOption(
    request: wisetime_user_timeline_v4_timeline_pb.SelectTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/SelectTimesheetFieldOption',
        request,
        metadata || {},
        this.methodDescriptorSelectTimesheetFieldOption,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/SelectTimesheetFieldOption',
    request,
    metadata || {},
    this.methodDescriptorSelectTimesheetFieldOption);
  }

  methodDescriptorClearTimesheetField = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/ClearTimesheetField',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.ClearTimesheetFieldRequest,
    wisetime_user_timeline_v4_timeline_pb.TimeGroup,
    (request: wisetime_user_timeline_v4_timeline_pb.ClearTimesheetFieldRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.TimeGroup.deserializeBinary
  );

  clearTimesheetField(
    request: wisetime_user_timeline_v4_timeline_pb.ClearTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  clearTimesheetField(
    request: wisetime_user_timeline_v4_timeline_pb.ClearTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  clearTimesheetField(
    request: wisetime_user_timeline_v4_timeline_pb.ClearTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/ClearTimesheetField',
        request,
        metadata || {},
        this.methodDescriptorClearTimesheetField,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/ClearTimesheetField',
    request,
    metadata || {},
    this.methodDescriptorClearTimesheetField);
  }

  methodDescriptorSelectRowTimesheetFieldOption = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/SelectRowTimesheetFieldOption',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.SelectRowTimesheetFieldOptionRequest,
    wisetime_user_timeline_v4_timeline_pb.SelectRowTimesheetFieldOptionResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.SelectRowTimesheetFieldOptionRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.SelectRowTimesheetFieldOptionResponse.deserializeBinary
  );

  selectRowTimesheetFieldOption(
    request: wisetime_user_timeline_v4_timeline_pb.SelectRowTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.SelectRowTimesheetFieldOptionResponse>;

  selectRowTimesheetFieldOption(
    request: wisetime_user_timeline_v4_timeline_pb.SelectRowTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.SelectRowTimesheetFieldOptionResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.SelectRowTimesheetFieldOptionResponse>;

  selectRowTimesheetFieldOption(
    request: wisetime_user_timeline_v4_timeline_pb.SelectRowTimesheetFieldOptionRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.SelectRowTimesheetFieldOptionResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/SelectRowTimesheetFieldOption',
        request,
        metadata || {},
        this.methodDescriptorSelectRowTimesheetFieldOption,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/SelectRowTimesheetFieldOption',
    request,
    metadata || {},
    this.methodDescriptorSelectRowTimesheetFieldOption);
  }

  methodDescriptorClearRowTimesheetField = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/ClearRowTimesheetField',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.ClearRowTimesheetFieldRequest,
    wisetime_user_timeline_v4_timeline_pb.ClearRowTimesheetFieldResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.ClearRowTimesheetFieldRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.ClearRowTimesheetFieldResponse.deserializeBinary
  );

  clearRowTimesheetField(
    request: wisetime_user_timeline_v4_timeline_pb.ClearRowTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.ClearRowTimesheetFieldResponse>;

  clearRowTimesheetField(
    request: wisetime_user_timeline_v4_timeline_pb.ClearRowTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.ClearRowTimesheetFieldResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.ClearRowTimesheetFieldResponse>;

  clearRowTimesheetField(
    request: wisetime_user_timeline_v4_timeline_pb.ClearRowTimesheetFieldRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.ClearRowTimesheetFieldResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/ClearRowTimesheetField',
        request,
        metadata || {},
        this.methodDescriptorClearRowTimesheetField,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/ClearRowTimesheetField',
    request,
    metadata || {},
    this.methodDescriptorClearRowTimesheetField);
  }

  methodDescriptorTrashTimeRows = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/TrashTimeRows',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.TrashTimeRowsRequest,
    wisetime_user_timeline_v4_timeline_pb.TrashTimeRowsResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.TrashTimeRowsRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.TrashTimeRowsResponse.deserializeBinary
  );

  trashTimeRows(
    request: wisetime_user_timeline_v4_timeline_pb.TrashTimeRowsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.TrashTimeRowsResponse>;

  trashTimeRows(
    request: wisetime_user_timeline_v4_timeline_pb.TrashTimeRowsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TrashTimeRowsResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.TrashTimeRowsResponse>;

  trashTimeRows(
    request: wisetime_user_timeline_v4_timeline_pb.TrashTimeRowsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TrashTimeRowsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/TrashTimeRows',
        request,
        metadata || {},
        this.methodDescriptorTrashTimeRows,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/TrashTimeRows',
    request,
    metadata || {},
    this.methodDescriptorTrashTimeRows);
  }

  methodDescriptorUnTrashTimeRows = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/UnTrashTimeRows',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.UnTrashTimeRowsRequest,
    wisetime_user_timeline_v4_timeline_pb.UnTrashTimeRowsResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.UnTrashTimeRowsRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.UnTrashTimeRowsResponse.deserializeBinary
  );

  unTrashTimeRows(
    request: wisetime_user_timeline_v4_timeline_pb.UnTrashTimeRowsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.UnTrashTimeRowsResponse>;

  unTrashTimeRows(
    request: wisetime_user_timeline_v4_timeline_pb.UnTrashTimeRowsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.UnTrashTimeRowsResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.UnTrashTimeRowsResponse>;

  unTrashTimeRows(
    request: wisetime_user_timeline_v4_timeline_pb.UnTrashTimeRowsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.UnTrashTimeRowsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/UnTrashTimeRows',
        request,
        metadata || {},
        this.methodDescriptorUnTrashTimeRows,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/UnTrashTimeRows',
    request,
    metadata || {},
    this.methodDescriptorUnTrashTimeRows);
  }

  methodDescriptorImmediatelyDeleteTimeRows = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/ImmediatelyDeleteTimeRows',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.ImmediatelyDeleteTimeRowsRequest,
    wisetime_user_timeline_v4_timeline_pb.ImmediatelyDeleteTimeRowsResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.ImmediatelyDeleteTimeRowsRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.ImmediatelyDeleteTimeRowsResponse.deserializeBinary
  );

  immediatelyDeleteTimeRows(
    request: wisetime_user_timeline_v4_timeline_pb.ImmediatelyDeleteTimeRowsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.ImmediatelyDeleteTimeRowsResponse>;

  immediatelyDeleteTimeRows(
    request: wisetime_user_timeline_v4_timeline_pb.ImmediatelyDeleteTimeRowsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.ImmediatelyDeleteTimeRowsResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.ImmediatelyDeleteTimeRowsResponse>;

  immediatelyDeleteTimeRows(
    request: wisetime_user_timeline_v4_timeline_pb.ImmediatelyDeleteTimeRowsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.ImmediatelyDeleteTimeRowsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/ImmediatelyDeleteTimeRows',
        request,
        metadata || {},
        this.methodDescriptorImmediatelyDeleteTimeRows,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/ImmediatelyDeleteTimeRows',
    request,
    metadata || {},
    this.methodDescriptorImmediatelyDeleteTimeRows);
  }

  methodDescriptorEmptyTrash = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/EmptyTrash',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.EmptyTrashRequest,
    wisetime_user_timeline_v4_timeline_pb.EmptyTrashResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.EmptyTrashRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.EmptyTrashResponse.deserializeBinary
  );

  emptyTrash(
    request: wisetime_user_timeline_v4_timeline_pb.EmptyTrashRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.EmptyTrashResponse>;

  emptyTrash(
    request: wisetime_user_timeline_v4_timeline_pb.EmptyTrashRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.EmptyTrashResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.EmptyTrashResponse>;

  emptyTrash(
    request: wisetime_user_timeline_v4_timeline_pb.EmptyTrashRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.EmptyTrashResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/EmptyTrash',
        request,
        metadata || {},
        this.methodDescriptorEmptyTrash,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/EmptyTrash',
    request,
    metadata || {},
    this.methodDescriptorEmptyTrash);
  }

  methodDescriptorCreateTimeGroup = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/CreateTimeGroup',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.CreateTimeGroupRequest,
    wisetime_user_timeline_v4_timeline_pb.TimeGroup,
    (request: wisetime_user_timeline_v4_timeline_pb.CreateTimeGroupRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.TimeGroup.deserializeBinary
  );

  createTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.CreateTimeGroupRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  createTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.CreateTimeGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  createTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.CreateTimeGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/CreateTimeGroup',
        request,
        metadata || {},
        this.methodDescriptorCreateTimeGroup,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/CreateTimeGroup',
    request,
    metadata || {},
    this.methodDescriptorCreateTimeGroup);
  }

  methodDescriptorCreateEmptyTimeGroup = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/CreateEmptyTimeGroup',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.CreateEmptyTimeGroupRequest,
    wisetime_user_timeline_v4_timeline_pb.TimeGroup,
    (request: wisetime_user_timeline_v4_timeline_pb.CreateEmptyTimeGroupRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.TimeGroup.deserializeBinary
  );

  createEmptyTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.CreateEmptyTimeGroupRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  createEmptyTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.CreateEmptyTimeGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  createEmptyTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.CreateEmptyTimeGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/CreateEmptyTimeGroup',
        request,
        metadata || {},
        this.methodDescriptorCreateEmptyTimeGroup,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/CreateEmptyTimeGroup',
    request,
    metadata || {},
    this.methodDescriptorCreateEmptyTimeGroup);
  }

  methodDescriptorAddToTimeGroup = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/AddToTimeGroup',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.AddToTimeGroupRequest,
    wisetime_user_timeline_v4_timeline_pb.TimeGroup,
    (request: wisetime_user_timeline_v4_timeline_pb.AddToTimeGroupRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.TimeGroup.deserializeBinary
  );

  addToTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.AddToTimeGroupRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  addToTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.AddToTimeGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  addToTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.AddToTimeGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/AddToTimeGroup',
        request,
        metadata || {},
        this.methodDescriptorAddToTimeGroup,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/AddToTimeGroup',
    request,
    metadata || {},
    this.methodDescriptorAddToTimeGroup);
  }

  methodDescriptorRemoveFromTimeGroup = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/RemoveFromTimeGroup',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.RemoveFromTimeGroupRequest,
    wisetime_user_timeline_v4_timeline_pb.TimeGroup,
    (request: wisetime_user_timeline_v4_timeline_pb.RemoveFromTimeGroupRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.TimeGroup.deserializeBinary
  );

  removeFromTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.RemoveFromTimeGroupRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  removeFromTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.RemoveFromTimeGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  removeFromTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.RemoveFromTimeGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/RemoveFromTimeGroup',
        request,
        metadata || {},
        this.methodDescriptorRemoveFromTimeGroup,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/RemoveFromTimeGroup',
    request,
    metadata || {},
    this.methodDescriptorRemoveFromTimeGroup);
  }

  methodDescriptorUpdateTimeGroup = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/UpdateTimeGroup',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.UpdateTimeGroupRequest,
    wisetime_user_timeline_v4_timeline_pb.TimeGroup,
    (request: wisetime_user_timeline_v4_timeline_pb.UpdateTimeGroupRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.TimeGroup.deserializeBinary
  );

  updateTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.UpdateTimeGroupRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  updateTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.UpdateTimeGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  updateTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.UpdateTimeGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/UpdateTimeGroup',
        request,
        metadata || {},
        this.methodDescriptorUpdateTimeGroup,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/UpdateTimeGroup',
    request,
    metadata || {},
    this.methodDescriptorUpdateTimeGroup);
  }

  methodDescriptorUpdateTimeGroupDuration = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/UpdateTimeGroupDuration',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.UpdateTimeGroupDurationRequest,
    wisetime_user_timeline_v4_timeline_pb.TimeGroup,
    (request: wisetime_user_timeline_v4_timeline_pb.UpdateTimeGroupDurationRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.TimeGroup.deserializeBinary
  );

  updateTimeGroupDuration(
    request: wisetime_user_timeline_v4_timeline_pb.UpdateTimeGroupDurationRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  updateTimeGroupDuration(
    request: wisetime_user_timeline_v4_timeline_pb.UpdateTimeGroupDurationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  updateTimeGroupDuration(
    request: wisetime_user_timeline_v4_timeline_pb.UpdateTimeGroupDurationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/UpdateTimeGroupDuration',
        request,
        metadata || {},
        this.methodDescriptorUpdateTimeGroupDuration,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/UpdateTimeGroupDuration',
    request,
    metadata || {},
    this.methodDescriptorUpdateTimeGroupDuration);
  }

  methodDescriptorDeleteTimeGroup = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/DeleteTimeGroup',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.DeleteTimeGroupRequest,
    google_protobuf_empty_pb.Empty,
    (request: wisetime_user_timeline_v4_timeline_pb.DeleteTimeGroupRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.DeleteTimeGroupRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.DeleteTimeGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteTimeGroup(
    request: wisetime_user_timeline_v4_timeline_pb.DeleteTimeGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/DeleteTimeGroup',
        request,
        metadata || {},
        this.methodDescriptorDeleteTimeGroup,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/DeleteTimeGroup',
    request,
    metadata || {},
    this.methodDescriptorDeleteTimeGroup);
  }

  methodDescriptorCreateTimelineMarker = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/CreateTimelineMarker',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.CreateTimelineMarkerRequest,
    wisetime_user_timeline_v4_timeline_pb.TimelineMarker,
    (request: wisetime_user_timeline_v4_timeline_pb.CreateTimelineMarkerRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.TimelineMarker.deserializeBinary
  );

  createTimelineMarker(
    request: wisetime_user_timeline_v4_timeline_pb.CreateTimelineMarkerRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.TimelineMarker>;

  createTimelineMarker(
    request: wisetime_user_timeline_v4_timeline_pb.CreateTimelineMarkerRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimelineMarker) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.TimelineMarker>;

  createTimelineMarker(
    request: wisetime_user_timeline_v4_timeline_pb.CreateTimelineMarkerRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimelineMarker) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/CreateTimelineMarker',
        request,
        metadata || {},
        this.methodDescriptorCreateTimelineMarker,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/CreateTimelineMarker',
    request,
    metadata || {},
    this.methodDescriptorCreateTimelineMarker);
  }

  methodDescriptorDeleteTimelineMarker = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/DeleteTimelineMarker',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.DeleteTimelineMarkerRequest,
    google_protobuf_empty_pb.Empty,
    (request: wisetime_user_timeline_v4_timeline_pb.DeleteTimelineMarkerRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteTimelineMarker(
    request: wisetime_user_timeline_v4_timeline_pb.DeleteTimelineMarkerRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteTimelineMarker(
    request: wisetime_user_timeline_v4_timeline_pb.DeleteTimelineMarkerRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteTimelineMarker(
    request: wisetime_user_timeline_v4_timeline_pb.DeleteTimelineMarkerRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/DeleteTimelineMarker',
        request,
        metadata || {},
        this.methodDescriptorDeleteTimelineMarker,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/DeleteTimelineMarker',
    request,
    metadata || {},
    this.methodDescriptorDeleteTimelineMarker);
  }

  methodDescriptorAddManualTime = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/AddManualTime',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.AddManualTimeRequest,
    wisetime_user_timeline_v4_timeline_pb.AddManualTimeResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.AddManualTimeRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.AddManualTimeResponse.deserializeBinary
  );

  addManualTime(
    request: wisetime_user_timeline_v4_timeline_pb.AddManualTimeRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.AddManualTimeResponse>;

  addManualTime(
    request: wisetime_user_timeline_v4_timeline_pb.AddManualTimeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.AddManualTimeResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.AddManualTimeResponse>;

  addManualTime(
    request: wisetime_user_timeline_v4_timeline_pb.AddManualTimeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.AddManualTimeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/AddManualTime',
        request,
        metadata || {},
        this.methodDescriptorAddManualTime,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/AddManualTime',
    request,
    metadata || {},
    this.methodDescriptorAddManualTime);
  }

  methodDescriptorCountFilteredTimeRows = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/CountFilteredTimeRows',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.CountFilteredTimeRowsRequest,
    wisetime_user_timeline_v4_timeline_pb.CountFilteredTimeRowsResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.CountFilteredTimeRowsRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.CountFilteredTimeRowsResponse.deserializeBinary
  );

  countFilteredTimeRows(
    request: wisetime_user_timeline_v4_timeline_pb.CountFilteredTimeRowsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.CountFilteredTimeRowsResponse>;

  countFilteredTimeRows(
    request: wisetime_user_timeline_v4_timeline_pb.CountFilteredTimeRowsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.CountFilteredTimeRowsResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.CountFilteredTimeRowsResponse>;

  countFilteredTimeRows(
    request: wisetime_user_timeline_v4_timeline_pb.CountFilteredTimeRowsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.CountFilteredTimeRowsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/CountFilteredTimeRows',
        request,
        metadata || {},
        this.methodDescriptorCountFilteredTimeRows,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/CountFilteredTimeRows',
    request,
    metadata || {},
    this.methodDescriptorCountFilteredTimeRows);
  }

  methodDescriptorClearTimeGroupErrors = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/ClearTimeGroupErrors',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.ClearTimeGroupErrorsRequest,
    wisetime_user_timeline_v4_timeline_pb.ClearTimeGroupErrorsResponse,
    (request: wisetime_user_timeline_v4_timeline_pb.ClearTimeGroupErrorsRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.ClearTimeGroupErrorsResponse.deserializeBinary
  );

  clearTimeGroupErrors(
    request: wisetime_user_timeline_v4_timeline_pb.ClearTimeGroupErrorsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.ClearTimeGroupErrorsResponse>;

  clearTimeGroupErrors(
    request: wisetime_user_timeline_v4_timeline_pb.ClearTimeGroupErrorsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.ClearTimeGroupErrorsResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.ClearTimeGroupErrorsResponse>;

  clearTimeGroupErrors(
    request: wisetime_user_timeline_v4_timeline_pb.ClearTimeGroupErrorsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.ClearTimeGroupErrorsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/ClearTimeGroupErrors',
        request,
        metadata || {},
        this.methodDescriptorClearTimeGroupErrors,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/ClearTimeGroupErrors',
    request,
    metadata || {},
    this.methodDescriptorClearTimeGroupErrors);
  }

  methodDescriptorMergeTimeGroups = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timeline.v4.TimelineService/MergeTimeGroups',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timeline_v4_timeline_pb.MergeTimeGroupsRequest,
    wisetime_user_timeline_v4_timeline_pb.TimeGroup,
    (request: wisetime_user_timeline_v4_timeline_pb.MergeTimeGroupsRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timeline_v4_timeline_pb.TimeGroup.deserializeBinary
  );

  mergeTimeGroups(
    request: wisetime_user_timeline_v4_timeline_pb.MergeTimeGroupsRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  mergeTimeGroups(
    request: wisetime_user_timeline_v4_timeline_pb.MergeTimeGroupsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void): grpcWeb.ClientReadableStream<wisetime_user_timeline_v4_timeline_pb.TimeGroup>;

  mergeTimeGroups(
    request: wisetime_user_timeline_v4_timeline_pb.MergeTimeGroupsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timeline_v4_timeline_pb.TimeGroup) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timeline.v4.TimelineService/MergeTimeGroups',
        request,
        metadata || {},
        this.methodDescriptorMergeTimeGroups,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timeline.v4.TimelineService/MergeTimeGroups',
    request,
    metadata || {},
    this.methodDescriptorMergeTimeGroups);
  }

}

